// -- React Libraries
import React from 'react';

// -- Components
import GridHeader from "../GridHeader/index";
import GridContent from "../GridContent/index";

// -- Styles
import StyleWrapper from "./Wrapper";

export default class GridDescription extends React.Component {
    constructor (props) {
        super(props);
        
        this.description = props.data.description;
        this.isLengthOk = props.data.isLengthOk;
        this.isSpellOk = props.data.isSpellOk;
        this.descriptionLength = props.data.descriptionLength;
        this.spellLines = props.data.spellLines;
    }

    render() {
        return (
            <StyleWrapper className="grid-score-summaries">
                <div className="summary-title">苹果商店内的描述</div>

                <div className="app-description" dangerouslySetInnerHTML={
                        {
                            __html: (this.description || "").replace("\r\n", "<br />").replace(/[\r\n]/gi, "<br />")
                        }
                    }
                ></div>
                
                <div className="grid-container">
                    {/* First Row */}
                    <GridHeader ok={this.isLengthOk} title="长度">{this.descriptionLength}个字元</GridHeader>
                    <GridHeader ok={this.isSpellOk} title="文法检查"></GridHeader>

                    {/* Second Row */}
                    <GridContent title={this.isLengthOk && "很好！"}>
                        {
                            this.isLengthOk && (
                                <div>
                                    应用描述的长度在一个合理范围内。
                                </div>
                            ) || (
                                <div>
                                    应用描述太
                                    {
                                        (this.descriptionLength > 3385) && (
                                            "长"
                                        ) || "短"
                                    }，尝试控制在589至3385个字元内。
                                </div>
                            )
                        }
                    </GridContent>

                    <GridContent title={this.isSpellOk && "很好！"} className="spell-check-content">
                        {
                            this.isSpellOk && (
                                <div>
                                    你的描述没有文法问题。
                                </div>
                            ) || (
                                <div>
                                    {/* {
                                        this.spellLines.map( item => {
                                            return (
                                                <div key={item.index}> - {item.reason} </div>
                                            )
                                        } )
                                    } */}
                                    你的描述有文法问题，请优化一下。
                                </div>
                            )
                        }
                    </GridContent>
                    
                    {/* Third Row */}
                    <GridContent title={"小窍门:"}>
                        - <span>首100名的应用里，有90％</span>的描述都在589至3385个字元内。
                        <br /><br />
                        
                        - <span>只有5%用户会按“展开”</span>观看被收起的描述。
                        <br /><br />

                        - 利用简明和吸睛的字眼，并加入CTA（用户行为号召）吸引用户。
                        <br /><br />

                        - 用户会根据应用的简介来选择下载与否。
                    </GridContent>
                </div>
            </StyleWrapper>
        );
    }
};


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/ScoreSummary/GridDescription/index.js